import { render, staticRenderFns } from "./UpdateForm3.vue?vue&type=template&id=191ceaee"
import script from "./UpdateForm3.vue?vue&type=script&lang=js"
export * from "./UpdateForm3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports